import { Component, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
@Component({
  selector: 'aig-modal-confirm-edit',
  imports: [ModalComponent],
  templateUrl: './modal-confirm-edit.component.html',
  styleUrl: './modal-confirm-edit.component.scss',
  standalone: true,
})
export class ModalConfirmEditComponent {
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  clickHide(): void {
    this.hideModal.emit(true);
  }
}
